/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   let variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   let cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise, it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

let cur_position = $(window).scrollTop();
if (cur_position > 0) {
  if (
    !$(".product_transparent_wrap #shopify-section-header .header").hasClass(
      "scrolled"
    )
  ) {
    $(".product_transparent_wrap #shopify-section-header .header").addClass(
      "scrolled"
    );
  }
} else {
  $(".product_transparent_wrap #shopify-section-header .header").addClass(
    "trans_header"
  );
}

$(window).on("scroll", function (event) {
  // deltaY obviously records vertical scroll, deltaX and deltaZ exist too.
  // this condition makes sure it's vertical scrolling that happened

  // wheeled up
  if ($(this).scrollTop() < 100) {
    if (
      $(".product_transparent_wrap #shopify-section-header .header").hasClass(
        "scrolled"
      )
    ) {
      $(
        ".product_transparent_wrap #shopify-section-header .header"
      ).removeClass("scrolled");
      $(".product_transparent_wrap #shopify-section-header .header").addClass(
        "trans_header"
      );
    }
  } else {
    // wheeled down
    if (
      !$(".product_transparent_wrap #shopify-section-header .header").hasClass(
        "scrolled"
      )
    ) {
      $(".product_transparent_wrap #shopify-section-header .header").addClass(
        "scrolled"
      );
      $(
        ".product_transparent_wrap #shopify-section-header .header"
      ).removeClass("trans_header");
    }
  }
});

$(document).ready(function () {
  $(".product_progress_bar_show_center").last().css("left", "calc(50% - 25px)");

  $(".product__info .sizze_select_btn").click(function () {
    let select_size;
    let current_select = $(this);
    select_size = $(this).attr("id");

    $(".product__info .sizze_select_btn").each(function (index) {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      }
    });

    $(this).addClass("selected");

    $(
      ".product__info .bold_option_radio .bold_option_value_element input"
    ).each(function (index) {
      if (select_size === $(this).val()) {
        $(this).attr("checked", true);
      }
    });
  });

  /* checking selected color */
  $(document).on("click", ".caret_color_options .option", function (event) {
    let selected_val = $(this).find(".color_val").text();
    let selected_val_nospace = selected_val.replace(/[_\W]+/g, "");
    let parent_widget = $(this).parents(".product-item").find("option");

    $(".caret_color_options .option").each(function (index) {
      if ($(this).hasClass("checked")) {
        $(this).removeClass("checked");
      }
    });

    $(parent_widget).each(function (index) {
      if ($(this).val() === selected_val_nospace) {
        $(this).prop("selected", true);
      }
    });

    $(this).addClass("checked");

    // save the variant id
    let variant_id;

    // change image
    let color_parent_widget = $(this)
      .parents(".product-item")
      .find(".color-swatch");
    $(color_parent_widget.find(".color-swatch__item")).each(function (index) {
      let nospace_color = $(this)
        .text()
        .replace(/[_\W]+/g, "");
      if (nospace_color === selected_val_nospace) {
        variant_id = $(this)
          .parent()
          .find(".color-swatch__radio")
          .attr("data-variant-id");
        $(this).trigger("click");
      }
    });

    // set variant id to form section
    $(this)
      .parents(".product-item")
      .find(".shopify-product-form input[name='id']")
      .val(variant_id);

    // change select option images
    let color_img = $(this).find(".color_image").html();

    $(this)
      .parents(".product-item")
      .find(".caret_selected_color_value")
      .html(color_img);
  });

  /* select size option */
  $(document).on("click", ".option .sizze_select_btn", function (event) {
    let select_size;
    let current_select = $(this);
    select_size = $(this).attr("data-target");

    $(".option .sizze_select_btn").each(function (index) {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      }
    });

    $(this).addClass("selected");

    // value display
    let current_size_val = $(this).attr("data-target");
    $(this)
      .parents(".actions")
      .find(".caret_selected_size_value")
      .text(current_size_val);

    // Bold app select option check
    let size_parent_widget = $(this)
      .parents(".product-item")
      .find(".product-form__buy-buttons");
    $(
      size_parent_widget.find(
        ".bold_option_radio .bold_option_value_element input"
      )
    ).each(function (index) {
      if (select_size === $(this).val()) {
        $(this).attr("checked", true);
      }
    });

    $(this)
      .parents(".variants")
      .find(".caret_size")
      .css("background", "#f1f1f1");
    $(this).parents(".variants").find(".caret_size").css("color", "#06038d");
    $(this)
      .parents(".variants")
      .find(".caret_size svg polyline")
      .css("stroke", "#06038d");
  });

  /* recommend product bag */
  $(document).on("click", ".recommend_add-to-bag", function () {
    let size_parent_widget = $(this)
      .parents(".row ")
      .find(".variants .recommend_field.selected .recommend_size_select_btn ");
    let selected_size = false;
    let variant_id = "";

    $(size_parent_widget).each(function (index) {
      if ($(this).hasClass("selected")) {
        selected_size = true;
        variant_id = $(this).attr("data-variant");
      }
    });

    if (!selected_size) {
      $(".select-notification").slideDown("slow", function () {
        // Animation complete.
      });

      setTimeout(function () {
        $(".select-notification").slideUp("slow", function () {
          // Animation complete.
        });
      }, 2000);

      // change background of size section
      $(this)
        .parents(".row ")
        .find(".selected.caret_size")
        .css("background", "#ffbe9f");
      $(this)
        .parents(".row ")
        .find(".selected.caret_size")
        .css("color", "#8a2d00");
      $(this)
        .parents(".row ")
        .find(".selected.caret_size svg polyline")
        .css("stroke", "#8a2d00");
    } else {
      // clicking the add to bug button
      $(this)
        .parents(".product-item")
        .find(".shopify-product-form input[name='id']")
        .val(variant_id);
      $(this)
        .parents(".product-item")
        .find(".shopify-product-form .product-form__add-button")
        .trigger("click");

      let cur_size_value_element = $(this)
        .parent()
        .find(".variants .recommend_field.selected .caret_selected_size_value");

      $(".recommend_field .caret_selected_size_value").each(function (index) {
        let size_value_element = $(this);

        if (
          cur_size_value_element.length == size_value_element.length &&
          cur_size_value_element.length ==
            cur_size_value_element.filter(size_value_element).length
        ) {
          // They are equal
        } else {
          $(this).text("SIZE");
        }
      });
    }
  });

  /* recommend size button click */
  $(document).on("click", ".recommend_option", function () {
    let product_target = $(this).attr("data-target");
    let parent_widget = $(this).parents(".variants ").find(".recommend_field");
    let featured_widtet = $(this)
      .parents(".recommend_product-item")
      .find(".product-item__aspect-ratio");
    let cur_price = $(this).attr("data-price");
    let cur_com_price = $(this).attr("data-com-price");

    // change button value
    if (cur_com_price) {
      $(this)
        .parents(".recommend_product-item")
        .find(".add-to-bag")
        .html(
          "ADD TO BAG -" +
            "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
            cur_price +
            "</div> <div class='display_price_oncartbtn price--compare'>" +
            cur_com_price +
            "</div></div>"
        );
    } else {
      $(this)
        .parents(".recommend_product-item")
        .find(".add-to-bag")
        .html(
          "ADD TO BAG -" +
            " <div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
            cur_price +
            "</div> </div>"
        );
    }

    $(parent_widget).each(function (index) {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      }

      $(parent_widget).find(".caret_size").css("background", "#f1f1f1");
      $(parent_widget).find(".caret_size").css("color", "#06038d");
      $(parent_widget)
        .find(".caret_size svg polyline")
        .css("stroke", "#06038d");
      $(parent_widget)
        .find(".caret_size .caret_selected_size_value")
        .text("SIZE");
    });

    $(parent_widget).each(function (index) {
      if ($(this).attr("data-parent") == product_target) {
        $(this).addClass("selected");
      }
    });

    $(featured_widtet).each(function (index) {
      if ($(this).hasClass("selected")) {
        $(this).removeClass("selected");
      }
    });

    $(featured_widtet).each(function (index) {
      if ($(this).attr("product_id") == product_target) {
        $(this).addClass("selected");
      }
    });
  });

  /* click special button */
  $(document).on("click", ".add-to-bag-special", function () {
    let variant_id;
    variant_id = $(this).data("variant_id");

    $(this)
      .parent()
      .parent()
      .parent()
      .parent(".product-item")
      .find(".shopify-product-form input[name='id']")
      .val(variant_id);
    $(this)
      .parent()
      .parent()
      .parent()
      .parent(".product-item")
      .find(".product-form__add-button")
      .trigger("click");
  });

  /* click add to cart button on collection and recommend product */
  $(document).on("click", ".add-to-bag-normal", function () {
    let size_parent_widget = $(this)
      .parents(".row ")
      .find(".variants .sizze_select_btn");
    let selected_size = false;
    let variant_id = "";

    $(size_parent_widget).each(function (index) {
      if ($(this).hasClass("selected")) {
        selected_size = true;
        variant_id = $(this).attr("data-variant");
      }
    });

    if (!selected_size) {
      $(".select-notification").slideDown("slow", function () {
        // Animation complete.
      });

      setTimeout(function () {
        $(".select-notification").slideUp("slow", function () {
          // Animation complete.
        });
      }, 2000);

      $(this)
        .parents(".row ")
        .find(".selected.caret_size")
        .css("background", "#ffbe9f");
      $(this)
        .parents(".row ")
        .find(".selected.caret_size")
        .css("color", "#8a2d00");
      $(this)
        .parents(".row ")
        .find(".selected.caret_size svg polyline")
        .css("stroke", "#8a2d00");
    } else {
      // clicking the add to bug button
      $(this)
        .parent()
        .parent()
        .parent()
        .parent(".product-item")
        .find(".shopify-product-form input[name='id']")
        .val(variant_id);
      $(this)
        .parent()
        .parent()
        .parent()
        .parent(".product-item")
        .find(".product-form__add-button")
        .trigger("click");

      let cur_size_value_element = $(this)
        .parent(".product_select_option_wrap")
        .find(".variants .caret_selected_size_value");

      $(".product-item .caret_selected_size_value").each(function (index) {
        let size_value_element = $(this);

        if (
          cur_size_value_element.length == size_value_element.length &&
          cur_size_value_element.length ==
            cur_size_value_element.filter(size_value_element).length
        ) {
          // They are equal
        } else {
          $(this).text("SIZE");
        }
      });
    }
  });

  /* mobile add to cart button on product page */
  $(document).on("click", ".add-to-bag_main_pro", function () {
    console.log('no-size:', this.classList.contains('no-size'));

    if (this.classList.contains('no-size')) {return false}

    $(this)
      .parents(".product-form")
      .find(".product-form__add-button ")
      .trigger("click");
  });

  // Adding mega menu image item
  $(".link--faded").each(function (index) {
    if ($(this).text() === "Slides") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/Slides_083f3393-dddf-4a7b-8f02-cd3053d10f22.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }

    if ($(this).text() === "Slip-Ons") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/Slipons_b23d9dfd-e332-4899-95ca-18b5a5fbf991.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }

    // This collection is no longer being sold
    /*if ($(this).text() === "Boots") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/boots_e4296f16-25ab-4e6a-8cb3-9d1e405fbc0d.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }*/

    if ($(this).text() === "Kids") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/Kids_1dcf8d06-5d8f-449b-a891-4890cffb0906.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }

    if ($(this).text() === "Socks") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/sock1.svg'>"
      );
      $(this).css("margin-left", "0px");
    }

    if ($(this).text() === "Candles") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/candle1.svg'>"
      );
      $(this).css("margin-left", "0px");
    }

    if ($(this).text() === "Gift Cards" || $(this).text() === "Shop All") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/gift.svg'>"
      );
      $(this).css("margin-left", "0px");
    }

    // This collection is no longer being sold
    /*if ($(this).text() === "Indoor Slippers") {
      $(this).prepend(
        "<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/indoorslide_a5180233-f544-4f4e-b74f-fcfc99aac89b.svg?v=1697131765'>"
      );
      $(this).css("margin-left", "0px");
    }*/
  });

  // change variant name on swatch name
  $(document).on("click", ".product__info .variant-swatch__item", function () {
    let selected_variant = $(this).find(".visually-hidden").text();
    $(".swatch_name_btn").text(selected_variant);
  });

  // scroll details
  $(document).on("click", "#details", function (e) {
    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $(".product-content_progress_wrap").offset().top - 200,
      },
      300,
      "linear"
    );
  });

  /*if ($(".kids-size-guide-container")) {
    if ($(".juniors-size-guide-container")) {
      $(".kids-size-guide-container").append($('.juniors-size-guide-container .inner-size-guide-container'))
    }
  }*/

  /* Turn on detail and hide detail popup */
  $(document).on("click", ".close-icon", function () {
    if ($("#size-guide-container").hasClass("open")) {
      $("#size-guide-container").removeClass("open");
    }

    if ($(".kids-size-guide-container").hasClass("open")) {
      $(".kids-size-guide-container").removeClass("open");
    }

    if ($(".juniors-size-guide-container").hasClass("open")) {
      $(".juniors-size-guide-container").removeClass("open");
    }

    if ($(".socks-size-guide-container").hasClass("open")) {
      $(".socks-size-guide-container").removeClass("open");
    }
  });

  $(document).on("click", "#size-guide", function () {
    if (!$("#size-guide-container").hasClass("open")) {
      $("#size-guide-container").addClass("open");
    }
  });

  $(document).on("click", "#kids-guide", function () {
    if (!$(".kids-size-guide-container").hasClass("open")) {
      $(".kids-size-guide-container").addClass("open");
    }
  });

  $(document).on("click", "#juniors-guide", function () {
    if (!$(".juniors-size-guide-container").hasClass("open")) {
      $(".juniors-size-guide-container").addClass("open");
    }
  });

  $(document).on("click", "#socks-guide", function () {
    if (!$(".socks-size-guide-container").hasClass("open")) {
      $(".socks-size-guide-container").addClass("open");
    }
  });

  // collection page details mobile
  $(document).on("click", ".details_dont_btn", function () {
    let selected_dot_name = $(this).attr("id");

    $(".details_slider_logo ").each(function (index) {
      let current_id = $(this).attr("id");

      if (selected_dot_name == "details_dot_1") {
        if (current_id == "details_slider_comfort") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });
            $(this).addClass("details_selected");
          }
        }
      } else if (selected_dot_name == "details_dot_2") {
        if (current_id == "details_slider_triple") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });
            $(this).addClass("details_selected");
          }
        }

        if (current_id == "details_slider_water") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });
            $(this).addClass("details_selected");
          }
        }
      } else if (selected_dot_name == "details_dot_3") {
        if (current_id == "details_slider_recycled") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });

            $(this).addClass("details_selected");
          }
        }
      } else if (selected_dot_name == "details_dot_4") {
        if (current_id == "details_slider_animal") {
          if (!$(this).hasClass("details_selected")) {
            $(".details_slider_logo ").each(function (index) {
              if ($(this).hasClass("details_selected")) {
                $(this).removeClass("details_selected");
              }
            });

            $(this).addClass("details_selected");
          }
        }
      }
    });
  });

  $(document).on(
    "click",
    ".details_slider_logos .details_slider_logo",
    function () {
      let selected_slider_name = $(this).attr("id");

      if (selected_slider_name == "details_slider_comfort") {
        $("#details_dot_1").trigger("click");
      } else if (selected_slider_name == "details_slider_triple") {
        $("#details_dot_2").trigger("click");
      } else if (selected_slider_name == "details_slider_recycled") {
        $("#details_dot_3").trigger("click");
      }
    }
  );

  $(document).on(
    "click",
    ".details_slider_scenario_logos .details_slider_logo",
    function () {
      let selected_slider_name = $(this).attr("id");

      if (selected_slider_name == "details_slider_comfort") {
        $("#details_dot_1").trigger("click");
      } else if (selected_slider_name == "details_slider_water") {
        $("#details_dot_2").trigger("click");
      } else if (selected_slider_name == "details_slider_recycled") {
        $("#details_dot_3").trigger("click");
      } else if (selected_slider_name == "details_slider_animal") {
        $("#details_dot_4").trigger("click");
      }
    }
  );

  // guid scroll
  let lastScrollLeft = 0;

  $(".size-scrollbar").scroll(function (event) {
    let curent_ScrollLeft = $(this).scrollLeft();

    if (curent_ScrollLeft > lastScrollLeft) {
      $("#size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".kids-size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".socks-size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".inner-size-guide-container[data-size-type='juniors'] .sizes").scrollLeft(curent_ScrollLeft);
    } else {
      $("#size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".kids-size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".socks-size-guide-container .sizes").scrollLeft(curent_ScrollLeft);
      $(".inner-size-guide-container[data-size-type='juniors'] .sizes").scrollLeft(curent_ScrollLeft);
    }

    lastScrollLeft = curent_ScrollLeft;
  });

  let size_lastScrollLeft = 0;

  $("#size-guide-container .sizes").scroll(function (event) {
    let curent_ScrollLeft = $(this).scrollLeft();

    if (curent_ScrollLeft > size_lastScrollLeft) {
      $(".size-scrollbar").scrollLeft(curent_ScrollLeft);
    } else {
      $(".size-scrollbar").scrollLeft(curent_ScrollLeft);
    }

    size_lastScrollLeft = curent_ScrollLeft;
  });

  // remain price on cart button
  $(document).on("click", ".block-swatch__item", function (event) {
    const $swatch = $(this);
    const $productForm = $swatch.parents(".product-form_wrap");
    const $addToBagButton = $productForm.find(".add-to-bag_main_pro");

    // Extract data attributes
    const data = {
      price: $swatch.attr("data-price"),
      comparePrice: $swatch.attr("data-com-price"),
      preorder: $swatch.attr("data-preorder"),
      variantId: $swatch.attr("data-variant"),
      sizeCode: $swatch.attr("data-sizecode"),
      inventory: $swatch.attr("data-inventory"),
      collectionProducts: JSON.parse($productForm.find(".product_collection_data").text()),
    };

    // Handle size code cookie
    if (data.sizeCode) {
      Cookies.set("sizecode", data.sizeCode);
    }

    // Update button content
    updateAddToBagButton($swatch, $addToBagButton, data);

    // Update sticky CTA
    updateStickyCTA();

    // Handle inventory status
    updateInventoryStatus(data.inventory);

    // Update Color Swatch States
    updateColorSwatchStates(data);
  });

  function findVariantById(products, variantId) {
    return products.flatMap(product => product.variants).find(variant => variant.id === variantId) || null;
  }

  function createVariantMap(products) {
    const variantMap = new Map();
    products.forEach(product => {
      product.variants.forEach(variant => {
        variantMap.set(variant.id, variant);
      });
    });
    return variantMap;
  }

  function updateColorSwatchStates(data) {
    if (typeof data !== 'object') return;
    const variantMap = createVariantMap(data.collectionProducts);
    const currentVariant = findVariantById(data.collectionProducts, parseInt(data.variantId));

    const { option1, option2, option3 } = currentVariant;

    data.collectionProducts.forEach(product => {
      let productSwatch = document.querySelector(`.featured_images_item[data_id="${product.id}"]`)
      if (productSwatch) {
        productSwatch.classList.remove('disabled-swatch');
      }
    });

    let filteredProducts = data.collectionProducts.filter(product =>
      product.variants.some(v =>
        v.option1 === option1 &&
        v.option2 === option2 &&
        v.option3 === option3 &&
        !v.available // Filter unavailable variants
      )
    );

    if (filteredProducts.length > 0) {
      filteredProducts.forEach(product => {
        let productSwatch = document.querySelector(`.featured_images_item[data_id="${product.id}"]`)
        if (productSwatch) {
          productSwatch.classList.add('disabled-swatch');
        }
      });
    }
  }

  function updateAddToBagButton($swatch, $addToBagButton, data) {
    $addToBagButton.removeClass("no-size");

    if ($swatch.parent().hasClass("is-disabled")) {
      renderOutOfStockButton($addToBagButton, data.variantId);
      return;
    }

    if (data.comparePrice) {
      renderButtonWithComparePrice($addToBagButton, data);
    } else {
      renderButtonWithSinglePrice($addToBagButton, data);
    }

    // Note: This appears to override the previous HTML settings
    // Keep it if this is intentional behavior
    $addToBagButton.html(
      `ADD TO BAG<div class='display_price_oncartbtn'>${data.price}</div>`
    );
  }

  function renderOutOfStockButton($button, variantId) {
    $button.html(
      `<div class='no_stock_message' data-variant='${variantId}'>NOTIFY ME WHEN BACK IN STOCK</div>`
    );
  }

  function renderButtonWithComparePrice($button, data) {
    const buttonText = data.preorder === "no_prorder" ? "ADD TO BAG" : "PREORDER NOW";
    $button.html(
      `${buttonText}  &nbsp;<div class='display_price_set'>
            <div class='display_price_oncartbtn'>${data.price}</div>
            <div class='display_price_oncartbtn price--compare'>${data.comparePrice}</div>
        </div>`
    );
  }

  function renderButtonWithSinglePrice($button, data) {
    const buttonText = data.preorder === "no_prorder" ? "ADD TO BAG" : "PREORDER NOW";
    $button.html(
      `${buttonText}  <div class='display_price_set'>
            <div class='display_price_oncartbtn'> &nbsp;${data.price}</div>
        </div>`
    );
  }

  function updateStickyCTA() {
    const $stickyCTA = $(".simple-sticky-cta.no-size");
    $stickyCTA
      .removeClass("no-size")
      .on("click", function() {
        simpleAddToBag(this);
      });
    $(".simple-sticky-cta span.state").text("add to bag - ");
  }

  function updateInventoryStatus(inventory) {
    $(".backorder_message").css("display", inventory === "sold_out" ? "block" : "none");
  }

  $(document).on(
    "click",
    ".show_desktop_bag_btn .no_stock_message",
    function (event) {
      let cur_variant_id = $(this).attr("data-variant");

      if (!cur_variant_id) {
        let pathname = window.location.href;
        const myArray = pathname.split("?variant=");

        cur_variant_id = parseInt(myArray[1]);
      }

      $(this)
        .parent()
        .parent()
        .find(".product_bis_trigger")
        .attr("data-variant-id", cur_variant_id);
      let collection_bis_button = $(this)
        .parent()
        .parent()
        .find(".product_bis_trigger");

      collection_bis_button[0].click();
    }
  );

  $(document).on(
    "click",
    ".show_mobile_bag_btn .no_stock_message",
    function (event) {
      let cur_variant_id = $(this).attr("data-variant");

      if (!cur_variant_id) {
        let pathname = window.location.href;
        const myArray = pathname.split("?variant=");

        cur_variant_id = parseInt(myArray[1]);
      }

      $(this)
        .parent()
        .parent()
        .find(".product_bis_trigger")
        .attr("data-variant-id", cur_variant_id);
      let collection_bis_button = $(this)
        .parent()
        .parent()
        .find(".product_bis_trigger");

      collection_bis_button[0].click();
    }
  );

  // Product select on Collection page
  $(document).on(
    "click",
    ".product_select_option_wrap .sizze_select_btn.recommend_size_select_btn",
    function (event) {
      let cur_price = $(this).attr("data-price");
      let cur_com_price = $(this).attr("data-com-price");
      let cur_preorder = $(this).attr("data-preorder");
      let cur_variant_id = $(this).attr("data-variant");

      if ($(this).hasClass("is-disabled")) {
        $(this)
          .parents(".product_select_option_wrap")
          .find(".add-to-bag")
          .html(
            "<div class='no_stock_message' data-variant='" +
              cur_variant_id +
              "'>NOTIFY ME WHEN BACK IN STOCK</div>"
          );
        $(this)
          .parents(".product-item.product-card")
          .find(".product-form__buy-buttons .product-form__add-button")
          .prop("disabled", true);
      } else {
        if (cur_com_price) {
          if (cur_preorder == "no_prorder") {
            $(this)
              .parents(".product_select_option_wrap")
              .find(".add-to-bag")
              .html(
                "ADD TO BAG -" +
                  "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
                  cur_price +
                  "</div> <div class='display_price_oncartbtn price--compare'>" +
                  cur_com_price +
                  "</div></div>"
              );
          } else {
            $(this)
              .parents(".product_select_option_wrap")
              .find(".add-to-bag")
              .html(
                "PREORDER NOW -" +
                  "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
                  cur_price +
                  "</div> <div class='display_price_oncartbtn price--compare'>" +
                  cur_com_price +
                  "</div></div>"
              );
          }
        } else {
          if (cur_preorder == "no_prorder") {
            $(this)
              .parents(".product_select_option_wrap")
              .find(".add-to-bag")
              .html(
                "ADD TO BAG -" +
                  "<div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
                  cur_price +
                  "</div> </div>"
              );
          } else {
            $(this)
              .parents(".product_select_option_wrap")
              .find(".add-to-bag")
              .html(
                "PREORDER NOW -" +
                  "<div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
                  cur_price +
                  "</div> </div>"
              );
          }
        }

        // $(this).parents(".product_select_option_wrap").find(".add-to-bag").html("ADD TO BAG - " + "<div class='display_price_oncartbtn'> &nbsp;" + cur_price + "</div>");
        $(this)
          .parents(".product-item.product-card")
          .find(".product-form__buy-buttons .product-form__add-button")
          .prop("disabled", false);
      }

      let cur_variant_inventory = $(this).attr("data-inventory");
      if (cur_variant_inventory == "sold_out") {
        $(this)
          .parents(".product-item.product-card")
          .find(".backorder_message_plp")
          .css("display", "block");
      } else {
        $(this)
          .parents(".product-item.product-card")
          .find(".backorder_message_plp")
          .css("display", "none");
      }
    }
  );

  // stock button click
  $(document).on(
    "click",
    ".product_select_option_wrap .no_stock_message",
    function (event) {
      let cur_variant_id = $(this).attr("data-variant");

      $(this)
        .parent()
        .parent()
        .find(".collection_bis_trigger")
        .attr("data-variant-id", cur_variant_id);
      let collection_bis_button = $(this)
        .parent()
        .parent()
        .find(".collection_bis_trigger");

      collection_bis_button[0].click();
    }
  );

  // recommend product item
  $(document).on(
    "click",
    ".recommend_product-item .sizze_select_btn.recommend_size_select_btn",
    function (event) {
      let cur_price = $(this).attr("data-price");
      let cur_com_price = $(this).attr("data-com-price");
      let cur_preorder = $(this).attr("data-preorder");
      let cur_variant_id = $(this).attr("data-variant");

      if ($(this).hasClass("is-disabled")) {
        $(this)
          .parents(".recommend_product-item")
          .find(".add-to-bag")
          .html(
            "<div class='no_stock_message' data-variant='" +
              cur_variant_id +
              "'>NOTIFY ME WHEN BACK IN STOCK</div>"
          );
        $(this)
          .parents(".recommend_product-item")
          .find(".product-form__buy-buttons .product-form__add-button")
          .prop("disabled", true);
      } else {
        if (cur_com_price) {
          if (cur_preorder == "no_prorder") {
            $(this)
              .parents(".recommend_product-item")
              .find(".add-to-bag")
              .html(
                "ADD TO BAG -" +
                  "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
                  cur_price +
                  "</div> <div class='display_price_oncartbtn price--compare'>" +
                  cur_com_price +
                  "</div></div>"
              );
          } else {
            $(this)
              .parents(".recommend_product-item")
              .find(".add-to-bag")
              .html(
                "PREORDER NOW -" +
                  "&nbsp;<div class='display_price_set'><div class='display_price_oncartbtn'>" +
                  cur_price +
                  "</div> <div class='display_price_oncartbtn price--compare'>" +
                  cur_com_price +
                  "</div></div>"
              );
          }
        } else {
          if (cur_preorder == "no_prorder") {
            $(this)
              .parents(".recommend_product-item")
              .find(".add-to-bag")
              .html(
                "ADD TO BAG -" +
                  " <div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
                  cur_price +
                  "</div> </div>"
              );
          } else {
            $(this)
              .parents(".recommend_product-item")
              .find(".add-to-bag")
              .html(
                "PREORDER NOW -" +
                  " <div class='display_price_set'><div class='display_price_oncartbtn'> &nbsp;" +
                  cur_price +
                  "</div> </div>"
              );
          }
        }

        // $(this).parents(".recommend_product-item").find(".add-to-bag").html("ADD TO BAG - " + "<div class='display_price_oncartbtn'> &nbsp;" + cur_price + "</div>");
        $(this)
          .parents(".recommend_product-item")
          .find(".product-form__buy-buttons .product-form__add-button")
          .prop("disabled", false);
      }

      let cur_variant_inventory = $(this).attr("data-inventory");
      if (cur_variant_inventory == "sold_out") {
        $(this)
          .parents(".product-item.product-card.recommend_product-item")
          .find(".backorder_message_recom")
          .css("display", "block");
      } else {
        $(this)
          .parents(".product-item.product-card.recommend_product-item")
          .find(".backorder_message_recom")
          .css("display", "none");
      }
    }
  );

  $(document).on(
    "click",
    ".recommend_add-to-bag .no_stock_message",
    function (event) {
      let cur_variant_id = $(this).attr("data-variant");
      $(this)
        .parent()
        .parent()
        .find(".recommend_field.selected .recommend_bis_trigger")
        .attr("data-variant-id", cur_variant_id);

      let collection_bis_button = $(this)
        .parent()
        .parent()
        .find(".recommend_field.selected .recommend_bis_trigger");
      collection_bis_button[0].click();
    }
  );

  /* select variant and change values and change url */
  function ChangeUrl(page, url) {
    if (typeof history.pushState != "undefined") {
      let obj = { Page: page, Url: url };
      history.pushState(obj, obj.Page, obj.Url);
    } else {
      alert("Browser does not support HTML5.");
    }
  }

  /*$(document).on("click", ".featured_images_item", function (event) {
    let product_id = $(this).attr("data_id");
    let product_url = $(this).attr("data_url");

    ChangeUrl("Page1", product_url);

    // change form
    $(".product-form_wrap").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change slider
    $(".product-thumbnails_wrap").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change meta images
    $(".product_meta_image_wrap").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change mete images slider
    $(".product_meta_carousel").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change product description
    $(".hide_product-tabs_tab").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    // change care instructions
    $(".care_instructions").each(function (index) {
      let current_id = $(this).attr("data_id");

      if (product_id == current_id) {
        if (!$(this).hasClass("selected")) {
          $(this).addClass("selected");
        }
      } else {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
        }
      }
    });

    /!* hide and show preorder message *!/
    $(".backorder_message").css("display", "none");

    $(".product-form_wrap.selected .block-swatch").each(function (index) {
      let cur_variant_inventory = $(this)
        .find(".block-swatch__radio")
        .attr("data-inventory");

      if (
        cur_variant_inventory == "sold_out" &&
        $(this).find(".block-swatch__radio").is(":checked")
      ) {
        $(this).find(".block-swatch__item").click();
      }
    });

    updateStickyCTAPrice();
  });*/

  /* hover change variant name */
  $(".featured_images_item").hover(
    function () {
      let select_title = $(
        "#selected_product_form .featured_images_item.selected"
      ).attr("data_title");
      let cur_title = $(this).attr("data_title");
      let title_color = cur_title.split(" - ");

      $(".swatch_name_btn").text(title_color[title_color.length - 1]);
    },
    function () {
      let select_title = $(
        "#selected_product_form .featured_images_item.selected"
      ).attr("data_title");
      let cur_title = $(this).attr("data_title");
      let title_color = select_title.split(" - ");

      $(".swatch_name_btn").text(title_color[title_color.length - 1]);
    }
  );

  /* Same position after redirect */
  /*$(document).on("click",".featured_images_item a",function(event) {
        let cur_position = $(window).scrollTop();

        localStorage.setItem('cur_position', cur_position);
    });

    $(document).ready(function(){
        if (localStorage.getItem('cur_position')) {
            // $(window).scrollTop(localStorage.getItem('cur_position'));
            $('html').animate({scrollTop:localStorage.getItem('cur_position')});
            localStorage.removeItem('cur_position');
        }
    });*/

  $(document).on("click", ".mobile-toolbar__item--filters", function (event) {
    $(".product-facet__filters.drawer").attr("open", "");
  });

  $(document).on("click", ".product-facet__filters", function (event) {
    let cur_position = $(window).scrollTop();
    localStorage.setItem("cur_position", cur_position);
  });

  /* add white background when mouse scroll on product page */
  $(document).ready(function () {
    let cur_position = $(window).scrollTop();

    if (cur_position > 0) {
      if (
        !$(
          ".product_transparent_wrap #shopify-section-header .header"
        ).hasClass("scrolled")
      ) {
        $(".product_transparent_wrap #shopify-section-header .header").addClass(
          "scrolled"
        );
      }
    }

    // no stock label to add to cart button
    $(".product-form__option-selector .block-swatch__radio").each(function (
      index
    ) {
      if ($(this).is(":checked")) {
        if ($(this).parent().hasClass("is-disabled")) {
          $(this)
            .parents(".product-form_wrap")
            .find(".add-to-bag_main_pro")
            .html(
              "<div class='no_stock_message'>NOTIFY ME WHEN BACK IN STOCK</div>"
            );
        }
      }
    });

    // add drawer class
    let win_width = $(window).width();

    if (win_width < 1200 && win_width > 1000) {
      $(".product-facet__filters").addClass("drawer ");
      $(".product-facet__filters").addClass("drawer--from-left");
    }

    // go to scroll policy terms
    let pathname = window.location.pathname;
    let page_url = window.location.href;
    let hostname = window.location.hostname;
    let last_part = "";

    if (pathname == "/pages/policies") {
      let parts = page_url.split("="),
        last_part = parts[parts.length - 1];

      if (last_part) {
        let link_target = "#ghost-" + last_part;

        $("html, body").animate(
          {
            scrollTop: $(link_target).offset().top,
          },
          700
        );
      }
    }

    // master products redirect
    if (pathname == "/collections/all") {
      window.location.href = "/collections/shop-all";
    }

    // master products redirect
    if (pathname == "/products/pelli") {
      window.location.href = "/products/pelli-indigo-coffee";
    }

    if (pathname == "/products/esto") {
      window.location.href = "/products/esto-chestnut-cord-lily";
    }

    if (pathname == "/products/gehry") {
      window.location.href = "/products/gehry-jet-black-lily";
    }

    if (pathname == "/products/guru") {
      window.location.href = "/products/guru-indigo-coffee";
    }

    if (pathname == "/products/guru-sherp") {
      window.location.href = "/products/guru-sherp-olive-night-waffle-oatmeal";
    }

    if (pathname == "/products/nomad") {
      window.location.href = "/products/nomad-goat-lily";
    }

    if (pathname == "/products/cino") {
      window.location.href = "/products/cino-mid-waffle-suede-goat-lily";
    }

    if (pathname == "/products/draper") {
      window.location.href = "/products/draper-waffle-chestnut-marshmallow";
    }

    if (pathname == "/products/scenario-kids-coffee") {
      window.location.href = "/products/scenario-kids-pb-coffee";
    }

    if (pathname == "/products/scenario-juniors") {
      window.location.href = "/products/scenario-juniors-pb-bone-white";
    }

    if (pathname == "/products/keychain") {
      window.location.href = "/products/lusso-cloud-keychain-bone-malt";
    }

    // faq page
    if (
      $(this).scrollTop() >=
      $(window).height() - $(".fixed-menu").height() - 160
    ) {
      $(".fixed-menu").addClass("fixed");
    } else {
      $(".fixed-menu").removeClass("fixed");
    }

    let scrollTop = $(this).scrollTop();

    // Faq page
    if ($("#ghost-placing-an-order").length != 0) {
      let topDistance_placing = $("#ghost-placing-an-order").offset().top;
      if (topDistance_placing - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "placing-an-order") {
            $(this).addClass("selected");
          }
        });
      }

      let topDistance_shipping = $("#ghost-shipping").offset().top;
      if (topDistance_shipping - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "shipping") {
            $(this).addClass("selected");
          }
        });
      }

      let topDistance_returns = $("#ghost-returns-exchanges").offset().top;
      if (topDistance_returns - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "returns-exchanges") {
            $(this).addClass("selected");
          }
        });
      }

      let topDistance_products = $("#ghost-our-products").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "our-products") {
            $(this).addClass("selected");
          }
        });
      }
    }

    // polices page
    if ($("#ghost-privacy-policy").length != 0) {
      let topDistance_products = $("#ghost-privacy-policy").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "privacy-policy") {
            $(this).addClass("selected");
          }
        });
      }

      topDistance_products = $("#ghost-terms-of-service").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "terms-of-service") {
            $(this).addClass("selected");
          }
        });
      }

      topDistance_products = $("#ghost-shipping").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "shipping") {
            $(this).addClass("selected");
          }
        });
      }
    }
  });

  // Faq page
  $(document).scroll(function () {
    if (
      $(this).scrollTop() >=
      $(window).height() - $(".fixed-menu").height() - 160
    ) {
      $(".fixed-menu").addClass("fixed");
    } else {
      $(".fixed-menu").removeClass("fixed");
    }

    let scrollTop = $(this).scrollTop();
    let bodyElement = document.body;

    // Faq page
    if (bodyElement.classList.contains("page-faq")) {
      updateFAQSection($, scrollTop);
    }

    // polices page
    if ($("#ghost-privacy-policy").length != 0) {
      let topDistance_products = $("#ghost-privacy-policy").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "privacy-policy") {
            $(this).addClass("selected");
          }
        });
      }

      topDistance_products = $("#ghost-terms-of-service").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "terms-of-service") {
            $(this).addClass("selected");
          }
        });
      }

      topDistance_products = $("#ghost-shipping").offset().top;
      if (topDistance_products - 10 < scrollTop) {
        $(".fixed-menu .link").each(function (index) {
          $(this).removeClass("selected");
        });

        $(".fixed-menu .link").each(function (index) {
          if ($(this).data("target") == "shipping") {
            $(this).addClass("selected");
          }
        });
      }
    }
  });

  // go to location
  $(document).on("click", ".fixed-menu .link", function (event) {
    let current_state = $(this).data("target");

    $(".fixed-menu .link").each(function (index) {
      $(this).removeClass("selected");
    });

    $(this).addClass("selected");
    let link_target = "#ghost-" + current_state;

    $("html, body").animate(
      {
        scrollTop: $(link_target).offset().top,
      },
      700
    );
  });

  $(document).on(
    "click",
    ".tertiary-section .options .option",
    function (event) {
      let current_state = $(this).data("target");

      $(".tertiary-section .options .option").each(function (index) {
        $(this).removeClass("checked");
      });

      $(this).addClass("checked");
      let link_target = "#ghost-" + current_state;

      $("html, body").animate(
        {
          scrollTop: $(link_target).offset().top + 10,
        },
        700
      );
    }
  );

  $(window).resize(function () {
    let win_width = $(window).width();
    if (win_width < 1200 && win_width > 1000) {
      $(".product-facet__filters").addClass("drawer ");
      $(".product-facet__filters").addClass("drawer--from-left");
    }

    /*let more_colors_state = (getCookie('more_colors_state') === 'true');
    let moreColorsButton = document.querySelector('[data-more-colors-btn]');

    console.log('more_colors_state:', more_colors_state)
    console.log('moreColorsButton:', moreColorsButton)*/
  });

  let products_on_page = "";
  let next_url = "";
  let load_more_btn = "";
  let load_more_spinner = "";

  $(document).on("click", ".load-more__btn", function (event) {
    products_on_page = $(".products-on-page");
    next_url = products_on_page.data("next-url");
    load_more_btn = $(".load-more__btn");
    load_more_spinner = $(".load-more__spinner");

    loadMoreProducts();
  });

  function loadMoreProducts() {
    $.ajax({
      url: next_url,
      type: "GET",
      dataType: "html",
      beforeSend: function () {
        load_more_btn.hide();
        load_more_spinner.show();
      },
    }).done(function (next_page) {
      load_more_spinner.hide();

      let new_products = $(next_page).find(".products-on-page");
      let new_url = new_products.data("next-url");

      if (new_url) load_more_btn.show();

      next_url = new_url;
      products_on_page.data("next-url", next_url);
      products_on_page.append(new_products.html());
    });
  }

  let flag_val = "true";
  let ajaxinateLoop = document.querySelector("#AjaxinateLoop");

  $(window).on("scroll", function () {
    if (!ajaxinateLoop) {
      return false;
    }

    if (
      $(window).scrollTop() >=
      $(ajaxinateLoop).offset().top +
        $(ajaxinateLoop).outerHeight() -
        window.innerHeight
    ) {
      if (flag_val === "true") {
        $(".load-more__btn").trigger("click");
        flag_val = "false";
      }

      if (flag_val === "false") {
        if ($(".load-more__btn").css("display") != "none") {
          flag_val = "true";
        }
      }

      // alert('You reached the end of the DIV');
    }
  });

  $(document).on(
    "click",
    ".questions-section .content.question",
    function (event) {
      let current_state = false;
      if ($(this).hasClass("open")) {
        current_state = true;
      }

      $(".questions-section .content.question").each(function (index) {
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
          $(this).find(".body").css("height", "0");
        }
      });

      if (current_state) {
        $(this).removeClass("open");
        $(this).find(".body").css("height", "0");
      } else {
        $(this).addClass("open");

        let p_height1 = 0;
        $(this)
          .find(".body p")
          .each(function (index) {
            p_height1 = p_height1 + $(this).height();
          });

        let p_height = $(this).find(".body p").height();

        $(this)
          .find(".body")
          .css("height", p_height1 + "px");
      }
    }
  );

  /*  $("#slide_fliky1").flickity({
    // options
    cellAlign: "center",
    contain: true,
    fade: true,
  });*/

  // add class to klaviyo form first image
});

let bodyEle = document.querySelector("body");
if (bodyEle.classList.contains("pdp-template")) {
  let lastKnownScrollPosition = 0;

  document.addEventListener("scroll", (event) => {
    lastKnownScrollPosition = window.scrollY;
    let selectedFormWrap = document.querySelector(".product-form_wrap");
    if (!selectedFormWrap) {
      return false;
    }
    let dataId = selectedFormWrap.getAttribute("data_id");
    if (typeof dataId !== "string") {
      return false;
    }
    let addToBagButtonMobile = document.querySelector(
      `.show_mobile_bag_btn[data-parent="product-card-${dataId}"]`
    );
    if (!addToBagButtonMobile) {
      return false;
    }
    let siteFooter = document.querySelector("#shopify-section-footer");
    if (!siteFooter) {
      return false;
    }

    let addToBagButtonMobileOffset =
      addToBagButtonMobile.getBoundingClientRect();
    let siteFooterOffset = siteFooter.offsetTop;
    let pdpStickyCTA = document.querySelector(".pdp-sticky-cta");

    if (!pdpStickyCTA) {
      return false;
    }

    let isMainAddToBagVisible = addToBagButtonMobileOffset.bottom >= 141;
    let isFooterVisible = lastKnownScrollPosition >= siteFooterOffset - 800;

    if (
      (isMainAddToBagVisible && !isFooterVisible) ||
      (isFooterVisible && !isMainAddToBagVisible)
    ) {
      pdpStickyCTA.style.display = "none";
    } else {
      pdpStickyCTA.style.display = "block";
    }
  });
}

function updateFAQSection($, scrollTop) {
  let placingAnOrderAnchor = document.querySelector("#ghost-placing-an-order");
  let shippingAnchor = document.querySelector("#ghost-shipping");
  let returnsExchangesAnchor = document.querySelector(
    "#ghost-returns-exchanges"
  );
  let ourProductsAnchor = document.querySelector("#ghost-our-products");
  let fixedMenuLinks = $(".fixed-menu .link");

  if (!placingAnOrderAnchor || !fixedMenuLinks.length) {
    return false;
  }

  let topDistance_placing = $(placingAnOrderAnchor).offset().top;
  if (topDistance_placing - 130 < scrollTop) {
    fixedMenuLinks.each(function (index) {
      $(this).removeClass("selected");
    });

    fixedMenuLinks.each(function (index) {
      if ($(this).data("target") == "placing-an-order") {
        $(this).addClass("selected");
      }
    });
  }

  let topDistance_shipping = $(shippingAnchor).offset().top;

  if (topDistance_shipping - 130 < scrollTop) {
    fixedMenuLinks.each(function (index) {
      $(this).removeClass("selected");
    });

    fixedMenuLinks.each(function (index) {
      if ($(this).data("target") == "shipping") {
        $(this).addClass("selected");
      }
    });
  }

  let topDistance_returns = $(returnsExchangesAnchor).offset().top;
  if (topDistance_returns - 130 < scrollTop) {
    fixedMenuLinks.each(function (index) {
      $(this).removeClass("selected");
    });

    fixedMenuLinks.each(function (index) {
      if ($(this).data("target") == "returns-exchanges") {
        $(this).addClass("selected");
      }
    });
  }

  let topDistance_products = $(ourProductsAnchor).offset().top;
  if (topDistance_products - 130 < scrollTop) {
    fixedMenuLinks.each(function (index) {
      $(this).removeClass("selected");
    });

    fixedMenuLinks.each(function (index) {
      if ($(this).data("target") == "our-products") {
        $(this).addClass("selected");
      }
    });
  }
}

function simpleAddToBag(simpleAddToBagButton) {
  if (!simpleAddToBagButton) {
    return false;
  }

  let variantSelected = simpleAddToBagButton.dataset.variantSelected;
  if (typeof variantSelected !== "string") {
    return false;
  }

  if (variantSelected === "true") {
    let mainAddToBag = document.querySelector(
      ".product-form_wrap form .add-to-bag_main_pro"
    );

    if (!mainAddToBag) {
      return false;
    }

    mainAddToBag.click();
  } else if (variantSelected === "false") {
    let blockSwatchList = getCurrentBlockSwatchList();

    if (!blockSwatchList) {
      return false;
    }
    let blockSwatchListOffsetTop = blockSwatchList.offsetTop - 400;
    let blockSwatchListOffsetLeft = blockSwatchList.offsetLeft - 400;

    window.scrollTo({
      top: blockSwatchListOffsetTop,
      left: blockSwatchListOffsetLeft,
      behavior: "smooth",
    });
  }
}

function updateStickyCTA(swatch) {
  if (!swatch) {
    return false;
  }

  let pdpStickyCTA = document.querySelector(".pdp-sticky-cta");
  if (!pdpStickyCTA) {
    return false;
  }
  let simpleAddToBagButton;

  if (pdpStickyCTA.dataset.ctaType === "simple") {
    simpleAddToBagButton = document.querySelector(".simple-sticky-cta");
    simpleAddToBagButton.setAttribute("data-variant-selected", "true");
  }
}

function updateStickyCTAPrice() {
  let mainAddToBag = document.querySelector(
    ".product-form_wrap.selected form .add-to-bag_main_pro"
  );
  if (!mainAddToBag) {
    return false;
  }

  let priceOnBtn = mainAddToBag.querySelector(".display_price_oncartbtn");
  if (!priceOnBtn) {
    return false;
  }

  let stickyPrice = document.querySelector(".sticky-price");
  if (!stickyPrice) {
    return false;
  }

  stickyPrice.innerHTML = priceOnBtn.innerHTML.replace(/\s+/g, "");
}

function getCurrentBlockSwatchList() {
  let selectedProductFormWrap = document.querySelector(".product-form_wrap");
  if (!selectedProductFormWrap) {
    return false;
  }

  let blockSwatchList =
    selectedProductFormWrap.querySelector(".block-swatch-list");
  if (!blockSwatchList) {
    return false;
  }

  return blockSwatchList;
}

$(function () {
  //js for size type buttons (mens/womans) on new pdp
  //store current block-swatch in array
  let mens_swatches = $(".block-swatch.men").clone(true).show();
  let womens_swatches = $(".block-swatch.women").clone(true).show();
  let active = "men";

  //console.log(mens_swatches);

  $("[data-size-type-btn]").on("click", function (e) {
    let _this = $(this);
    let btnLabel = $(this).text().replace(/\s+/g, " ");
    let currentPathname = window.location.pathname;

    if (btnLabel.includes('Juniors') || btnLabel.includes('Kids')) {
      $("[data-size-type-btn]")
        .removeClass("tw-bg-lusso-blue")
        .removeClass("tw-text-white")
        .removeClass("active-size-type");

      _this
        .addClass("tw-bg-lusso-blue")
        .addClass("tw-text-white")
        .addClass("active-size-type");

      if (currentPathname.includes('scenario-juniors')) {
        if (btnLabel.includes('Little Kids')) {
          window.location = '/products/scenario-kids';
        }
      } else if (currentPathname.includes('scenario-kids')) {
        if (btnLabel.includes('Big Kids')) {
          window.location = '/products/scenario-juniors';
        }
      }
    } else {
      let currentState = $(".add-to-bag_main_pro").each(function () {
        //console.log($(this).html());

        $(this)
          .addClass("no-size")
          .html($(this).html().replace("ADD TO BAG", "SELECT A SIZE"));
      });
      $(".simple-sticky-cta")
        .addClass("no-size")
        .find(".state")
        .text("SELECT A SIZE")
        .off("click");
      $("[data-size-type-btn]")
        .removeClass("tw-bg-lusso-blue")
        .removeClass("tw-text-white")
        .removeClass("active-size-type");
      $(this)
        .addClass("tw-bg-lusso-blue")
        .addClass("tw-text-white")
        .addClass("active-size-type");

      let size_type = $(this).attr("data-size-type");

      if (size_type !== active) {
        $(".block-swatch-list").html("");

        if (size_type === "women") {
          $(womens_swatches).clone(true).appendTo(".block-swatch-list");
        } else {
          $(mens_swatches).clone(true).appendTo(".block-swatch-list");
        }

        active = size_type;
        $("[data-active-size-type]").find("span").text(active);
      }

      setDataSizeTypeCookie();

      window.storedProductVariants._updateDisableSelectors();
    }
  });

  let sizecode = Cookies.get("sizecode");
  if (sizecode) {
    setTimeout(function () {
      $(`.block-swatch__item[data-sizecode="${sizecode}"]`).trigger("click");
      //console.log(`[data-sizecode="${sizecode}"]`);
    }, 123);
  }
  //js for more colors + toggle on new pdp
  $("[data-more-colors-btn]").on("click", function (e) {
    $(".featured_images_wrap").toggleClass("full");
    const symbol = $(this).find("span.btn-symbol").text();
    const label = $(this).find("span.btn-label").text();
    $(this)
      .find("span.btn-symbol")
      .text(symbol === "+" ? "-" : "+");
    $(this)
      .find("span.btn-label")
      .text(label === "More Colors" ? "Less Colors" : "More Colors");

    setMoreColorsCookie($, true);
  });

  //js for more images + toggle on new pdp
  $("[data-more-images-btn]").on("click", function (e) {
    $(".product__media-grid-list").toggleClass("full");
    const symbol = $(this).find("span.btn-symbol").text();
    const label = $(this).find("span.btn-label").text();
    $(this)
      .find("span.btn-symbol")
      .text(symbol === "+" ? "-" : "+");
    $(this)
      .find("span.btn-label")
      .text(label === "Show More" ? "Show Less" : "Show More");
  });

  checkForActiveSizeType($);
  checkForMoreColorsCookie($);
});

// adding mobile menu image item
$(".mobile-nav.list--unstyled .mobile-nav__item .mobile-nav__link, .shop-all-links ul li a").each(
  function (index) {
    if ($(this).text() === "Slides") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[0]}'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if ($(this).text() === "Slip-Ons") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[1]}'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    // This collection is no longer being sold
    /*if ($(this).text() === "Boots") {
			$(this).prepend(
				"<img src='https://cdn.shopify.com/s/files/1/0451/6947/5752/files/boots_e4296f16-25ab-4e6a-8cb3-9d1e405fbc0d.svg?v=1697131765'>"
			);
			$(this).css("margin-left", "0px");
			$(this).css("justify-content", "flex-start");
		}*/

    if ($(this).text() === "Kids") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[2]}'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if ($(this).text() === "Socks") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/sock1.svg'>"
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if ($(this).text() === "Candles") {
      $(this).prepend(
        "<img src='//cdn.shopify.com/s/files/1/0451/6947/5752/files/candle1.svg'>"
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if ($(this).text() === "Gift Cards" || $(this).text() === "Accessories") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[4]}'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }

    if ($(this).text() === "House Slides" || $(this).text() === "Indoor") {
      $(this).prepend(
        `<img src='${window.mobileLinkImages[3]}'>`
      );
      $(this).css("margin-left", "0px");
      $(this).css("justify-content", "flex-start");
    }
  }
);

const fliConfig = {
  childList: true,
  subtree: true
}

const fliCallback = (mutationsList, observer) => {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
      return addFilterLabelIcons();
    }
  });
}

if (document.body.classList.contains('collection_page')) {
  const fliObserver = new MutationObserver(fliCallback);
  fliObserver.observe(document.querySelector('#facet-main'), fliConfig);

  addFilterLabelIcons();
}

function addFilterLabelIcons() {
  let filterLabelIcon = document.querySelector('.filter-label-icons-data');
  if (!filterLabelIcon) { return false }
  let filterLabelIconData = JSON.parse(filterLabelIcon.innerHTML);
  if (typeof filterLabelIconData !== 'object') { return false }

  let filterLabels = document.querySelectorAll('[data-filter-label]');
  if (!filterLabels.length) { return false }

  filterLabels.forEach((filterLabel) => {
    let associatedData = filterLabelIconData.find(fli => fli.label === filterLabel.dataset.filterLabel);
    if (associatedData) {
      let icon = filterLabel.querySelector('img');
      if (icon) { return false }

      let img = document.createElement('img');
      img.src = associatedData.icon;
      img.alt = associatedData.label;

      filterLabel.prepend(img);
    }
  });
}

function createCookie(name, value, days) {
  let expires;
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(name) {
  // Split cookie string and get all individual name=value pairs in an array
  let cookieArr = document.cookie.split(";");

  // Loop through the array elements
  for (const element of cookieArr) {
    let cookiePair = element.split("=");

    /* Removing whitespace at the beginning of the cookie name
		and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
}

function setDataSizeTypeCookie() {
  let activeSizeTypeButton = document.querySelector(".active-size-type");
  if (!activeSizeTypeButton) {
    return false;
  }

  let active_size_type = activeSizeTypeButton.dataset.sizeType;
  if (typeof active_size_type !== "string") {
    return false;
  }

  createCookie("active_size_type", active_size_type, 1);
}

function setMoreColorsCookie($) {
  let moreColorsButton = document.querySelector("[data-more-colors-btn]");
  if (!moreColorsButton) {
    return false;
  }

  let more_colors_state = getCookie("more_colors_state") === "true";
  let windowWidth = window.innerWidth;
  if (windowWidth < 1024) {
    return false;
  }

  if (more_colors_state === null) {
    return createCookie("more_colors_state", true, 1);
  } else {
    createCookie("more_colors_state", !more_colors_state, 1);
  }
}

function checkForActiveSizeType($) {
  let active_size_type = getCookie("active_size_type");
  if (
    typeof active_size_type !== "string" &&
    (active_size_type !== "men" || active_size_type !== "women")
  ) {
    return false;
  }

  let activeSizeTypeButton = document.querySelector(
    `[data-size-type="${active_size_type}"]`
  );
  if (!activeSizeTypeButton) {
    return false;
  }

  activeSizeTypeButton.click();
}

function checkForMoreColorsCookie($) {
  let more_colors_state = getCookie("more_colors_state") === "true";
  let moreColorsButton = document.querySelector("[data-more-colors-btn]");

  if (!moreColorsButton || !more_colors_state) {
    return false;
  }

  let symbol = moreColorsButton.querySelector("span.btn-symbol");
  let label = moreColorsButton.querySelector("span.btn-label");
  let featuredImagesWrap = document.querySelector(".featured_images_wrap ");
  if (!symbol || !label || !featuredImagesWrap) {
    return false;
  }

  let windowWidth = window.innerWidth;
  if (windowWidth > 1023) {
    featuredImagesWrap.classList.add("full");
    symbol.innerHTML = "-";
    label.innerHTML = "Show Less";
  } else {
    featuredImagesWrap.classList.remove("full");
    symbol.innerHTML = "+";
    label.innerHTML = "Show More";
  }
}
